/**
 * Site Manager Cockpit — runtime configuration.
 *
 * One module for the API base and the MSAL app registration so a
 * test/fixture mode can swap both without touching call sites. Values match
 * the CIS Capture app (azure-apps/cis-capture/app/js/msal-auth.js,
 * js/api.js) — same tenant, same app registration, same API scope, same
 * DEV function app origin.
 */

"use strict";

export const AUTH_CONFIG = {
  clientId: "5691666c-3b75-4591-a927-7ea46de97dca",
  tenantId: "496517b4-91ec-4197-9423-03ad743b9ed0",
  apiScope: "api://5691666c-3b75-4591-a927-7ea46de97dca/access_as_user",
};

// A <meta name="cis-api-base"> override lets a deployed environment point
// elsewhere without a rebuild; falls back to the DEV function app.
export const API_BASE =
  (document.querySelector('meta[name="cis-api-base"]') || {}).content ||
  "https://func-neg-cis-dev.azurewebsites.net";

/**
 * CIS Capture, where "Record now" on End of day opens the project's Scheduled
 * list. A <meta name="cis-capture-url"> override lets a deployed environment
 * point elsewhere; the default is the production capture app.
 */
export const CAPTURE_URL =
  (document.querySelector('meta[name="cis-capture-url"]') || {}).content ||
  "https://cis.neg-marine.com";

/** The capture app opened on a project (its `?project=` query selects the project). */
export function captureUrlFor(code, base = CAPTURE_URL) {
  return `${String(base).replace(/\/+$/, "")}/?project=${encodeURIComponent(code || "")}`;
}

/** True when the app should run against fixture data with no MSAL/network. */
export function fixtureModeFromLocation(location = window.location) {
  const params = new URLSearchParams(location.search);
  const value = params.get("fixture");
  return value ? value : null;
}

/** `?fixture=report-v2&state=<state>`: which sample state of the design the fixture shows (default "draft"). */
export function fixtureStateFromLocation(location = window.location) {
  const params = new URLSearchParams(location.search);
  return params.get("state") || "draft";
}

export function themeFromLocation(location = window.location) {
  const params = new URLSearchParams(location.search);
  return params.get("theme") === "light" ? "light" : "dark";
}
